import React from "react";

const DesktopPreview = ({
  primaryColor,
  secondaryColor,
  backgroundColor,
  textPrimary,
  textSecondary,
  logoBase64,
  backgroundImage,
}) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingBottom: "56.25%", // 16:9 aspect ratio
        backgroundColor: backgroundColor || "#f3f3f3",
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* Header */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "60px",
          background: `linear-gradient(to right, ${primaryColor || "#01315f"}, ${secondaryColor || "#067ddb"})`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        {logoBase64 && (
          <img
            src={logoBase64}
            alt="Logo"
            style={{ height: "20px", objectFit: "contain" }}
          />
        )}
        <div style={{ color: "white", display: "flex", alignItems: "center" }}>
          <i className="fas fa-globe mr-1"></i> ES
        </div>
      </div>

      {/* Content area with background color overlay */}
      <div
        style={{
          position: "absolute",
          top: "60px",
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: backgroundColor || "#f3f3f3",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        <div style={{ textAlign: "center", maxWidth: "80%" }}>
          <h2 style={{ 
            color: textPrimary || "#01315f", 
            fontSize: "24px",
            fontWeight: "600",
            marginBottom: "10px"
          }}>
            Título de ejemplo
          </h2>
          <p style={{ 
            color: textSecondary || "#01315f", 
            fontSize: "14px",
            lineHeight: "1.5"
          }}>
            Este texto demuestra cómo el color de fondo con opacidad mejora la legibilidad sobre imágenes complejas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DesktopPreview;
